import { CenteredBlock } from "./CenteredBlock";
import React from "react";

export const MainContent: React.FC = () => {
  return <CenteredBlock>Choose an option from the Navigation</CenteredBlock>;
};
